import $ from 'jquery';

window.addEventListener('px-ready', function() {
    $(window).resize(function() {
        $('.px-header').parent().css('height', $('.px-header').outerHeight());
        if($('.px-header').outerHeight() > 150){
            window.setTimeout(function() {
                $(window).trigger('resize')
            }, 100);
        }
    }).trigger('resize');
    
    $('body').attr('scrollb4', 0);
    $('body').attr('menuDisplace', 0);
    $(window).on('scroll', function() {
        let scrollb4 = parseInt($('body').attr('scrollb4'));
        let scroll = $(window).scrollTop().valueOf();
        let menuDisplace = parseInt($('body').attr('menuDisplace'));
        let menuH = $('.px-header').outerHeight();
        //let quickmenuH = $('.px-quickmenu').outerHeight();
        let quickmenuH = 0;
        let menuMaxH = menuH + quickmenuH + 50;

        $('body').attr('scrollb4', scroll);
        let newScrollLoc = scroll-scrollb4;
        menuDisplace += parseInt(newScrollLoc);
        if (menuDisplace < 0) { menuDisplace = 0; }
        if (menuDisplace > menuMaxH) { menuDisplace = menuMaxH; }
        $('body').attr('menuDisplace', menuDisplace);
        menuDisplace -= quickmenuH;
        if (menuDisplace < 0) { menuDisplace = 0; }
        /*if (scroll < menuMaxH) {
            menuDisplace = 0;
        }*/

        if (scroll < menuMaxH) {
            $('.l-header').css('top', '0');
            $('body').attr('scrollb4', 0);
            $('body').attr('menuDisplace', 0);
        } else{
            $('.l-header').css('top', '-' + menuDisplace + 'px');
        }
    }).trigger('scroll');

    window.setTimeout(function() {
        $(window).trigger('scroll');
        $(window).trigger('resize');
    }, 1000)
});
